<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
          <h5 class="mb-0" style="color: #141414;">
            {{ 'TrustedDevices.title' | translate }}
          </h5>
          <button
            *ngIf="canMarkCurrentTrusted"
            type="button"
            class="btn btn-primary"
            (click)="markCurrentTrusted()">
            {{ 'TrustedDevices.markThisDevice' | translate }}
          </button>
        </div>
        <div class="card-body">
          <p class="trusted-devices-intro mb-2">
            {{ 'TrustedDevices.securityReassurance' | translate }}
          </p>
          <div class="alert alert-info py-2 px-3 small mb-3 d-flex align-items-center" role="note">
            <i class="fa fa-info-circle me-2" aria-hidden="true"></i>
            <span>{{ 'TrustedDevices.trustDuration' | translate: { days: trustDurationDays } }}</span>
          </div>
          <div *ngIf="loading" class="text-center py-4">
            <span class="spinner-border spinner-border-sm" role="status"></span>
          </div>
          <div *ngIf="!loading && devices.length === 0" class="alert alert-info">
            {{ 'TrustedDevices.noDevices' | translate }}
          </div>

          <!-- Mobile: card list (visible only on small screens) -->
          <div *ngIf="!loading && devices.length > 0" class="trusted-devices-mobile d-md-none">
            <div class="device-card" *ngFor="let device of devices">
              <div class="device-card-header" (click)="toggleDetails(device)">
                <div class="device-card-title-row">
                  <span class="device-card-label">{{ deviceFriendlyLabel(device) }}</span>
                  <i class="fa device-card-chevron" [ngClass]="isExpanded(device) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                </div>
                <div class="device-card-badges">
                  <span *ngIf="sessionStatus(device) === 'active'" class="badge bg-success">{{ 'TrustedDevices.sessionActive' | translate }}</span>
                  <span *ngIf="sessionStatus(device) === 'ended'" class="badge bg-secondary">{{ 'TrustedDevices.sessionEnded' | translate }}</span>
                  <span *ngIf="isCurrentDevice(device)" class="badge bg-success">{{ 'TrustedDevices.currentDevice' | translate }}</span>
                  <span *ngIf="device.is_trusted" class="badge bg-primary">{{ 'TrustedDevices.trusted' | translate }}</span>
                </div>
              </div>
              <div class="device-card-body">
                <div class="device-card-row">
                  <span class="device-card-meta-label">{{ 'TrustedDevices.sessionId' | translate }}</span>
                  <span class="device-card-meta-value">#{{ device.login_id }}</span>
                </div>
                <div class="device-card-row">
                  <span class="device-card-meta-label">{{ 'TrustedDevices.location' | translate }}</span>
                  <span class="device-card-meta-value">
                    <span *ngIf="locationLabel(device) !== '—'">{{ locationLabel(device) }}</span>
                    <span *ngIf="locationLabel(device) === '—' && isLocationUnavailable(device)" class="location-not-available">{{ locationNotAvailableText }}</span>
                    <span *ngIf="locationLabel(device) === '—' && !isLocationUnavailable(device)">—</span>
                  </span>
                </div>
                <div class="device-card-actions">
                  <button
                    *ngIf="device.is_trusted"
                    type="button"
                    class="btn btn-sm btn-outline-danger device-card-btn"
                    (click)="revoke(device); $event.stopPropagation()">
                    {{ 'TrustedDevices.remove' | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary device-card-btn"
                    (click)="forceLogout(device); $event.stopPropagation()"
                    [title]="'TrustedDevices.forceLogout' | translate">
                    <i class="fa fa-sign-out me-1"></i>{{ 'TrustedDevices.forceLogout' | translate }}
                  </button>
                  <button
                    *ngIf="!device.is_trusted && isCurrentDevice(device)"
                    type="button"
                    class="btn btn-sm btn-outline-primary device-card-btn"
                    (click)="markAsTrusted(device); $event.stopPropagation()">
                    {{ 'TrustedDevices.markThisDevice' | translate }}
                  </button>
                </div>
              </div>
              <div class="device-card-details" *ngIf="isExpanded(device)">
                <div class="device-details-inner">
                  <div class="session-overview">
                    <h6 class="device-details-section-title">{{ 'TrustedDevices.sessionOverview' | translate }}</h6>
                    <div class="session-overview-grid session-overview-grid-mobile">
                      <div class="session-overview-item">
                        <span class="session-overview-label">{{ 'TrustedDevices.deviceInfo' | translate }}</span>
                        <span class="session-overview-value">{{ deviceFriendlyLabel(device) }}</span>
                      </div>
                      <div class="session-overview-item">
                        <span class="session-overview-label">{{ 'TrustedDevices.location' | translate }}</span>
                        <span class="session-overview-value">
                          <span *ngIf="locationLabel(device) !== '—'">{{ locationLabel(device) }}</span>
                          <span *ngIf="locationLabel(device) === '—' && isLocationUnavailable(device)" class="location-not-available">{{ locationNotAvailableText }}</span>
                          <span *ngIf="locationLabel(device) === '—' && !isLocationUnavailable(device)">—</span>
                        </span>
                      </div>
                      <div class="session-overview-item">
                        <span class="session-overview-label">{{ 'TrustedDevices.sessionStarted' | translate }}</span>
                        <span class="session-overview-value">{{ formatDate(device.created_at) }}</span>
                      </div>
                      <div class="session-overview-item" *ngIf="device.is_trusted">
                        <span class="session-overview-label">{{ 'TrustedDevices.validUntil' | translate }}</span>
                        <span class="session-overview-value">
                          {{ formatDate(trustExpiresAt(device)) }}
                          <span class="expires-in-days ms-1" *ngIf="daysUntilTrustExpires(device) !== null">({{ 'TrustedDevices.expiresInDays' | translate: { count: daysUntilTrustExpires(device) } }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="technical-details-toggle mt-3">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleTechnicalDetails(device); $event.stopPropagation()">
                      <i class="fa me-1" [ngClass]="isTechnicalDetailsShown(device) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                      {{ isTechnicalDetailsShown(device) ? ('TrustedDevices.hideTechnicalDetails' | translate) : ('TrustedDevices.showTechnicalDetails' | translate) }}
                    </button>
                  </div>
                  <div class="technical-details-block mt-2" *ngIf="isTechnicalDetailsShown(device)">
                    <div class="row g-2 device-details-fields">
                      <div class="col-12"><strong>{{ 'TrustedDevices.sessionId' | translate }}:</strong> #{{ device.login_id }}</div>
                      <div class="col-12" *ngIf="sessionFingerprintShort(device)"><strong>{{ 'TrustedDevices.sessionFingerprint' | translate }}:</strong> <code class="device-details-code small">{{ sessionFingerprintShort(device) }}</code></div>
                      <div class="col-12" *ngIf="userAgentFriendly(device.user_agent)"><strong>{{ 'TrustedDevices.browserSummary' | translate }}:</strong> {{ userAgentFriendly(device.user_agent) }}</div>
                      <div class="col-12" *ngIf="device.user_agent">
                        <strong class="d-block mb-1">{{ 'TrustedDevices.userAgent' | translate }}:</strong>
                        <div class="user-agent-block user-agent-raw">{{ device.user_agent }}</div>
                      </div>
                      <ng-container *ngIf="isCurrentDevice(device) && clientDeviceDetails">
                        <div class="col-12 mt-2"><h6 class="device-details-section-title small">{{ 'TrustedDevices.sectionLiveDevice' | translate }}</h6></div>
                        <div class="col-12" *ngFor="let item of clientDetailKeys; trackBy: trackByClientDetailKey">
                          <span *ngIf="clientDeviceDetails[item.key] != null || (item.key === 'timezoneOffset')">
                            <strong>{{ item.labelKey | translate }}:</strong> {{ formatClientDetailValue(item.key, clientDeviceDetails[item.key]) }}
                          </span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Desktop: table (hidden on small screens) -->
          <div *ngIf="!loading && devices.length > 0" class="table-responsive trusted-devices-table d-none d-md-block">
            <table class="table table-hover align-middle">
              <thead>
                <tr>
                  <th style="width: 2rem;"></th>
                  <th>{{ 'TrustedDevices.sessionId' | translate }}</th>
                  <th>{{ 'TrustedDevices.deviceInfo' | translate }}</th>
                  <th>{{ 'TrustedDevices.location' | translate }}</th>
                  <th>{{ 'TrustedDevices.sessionStarted' | translate }}</th>
                  <th>{{ 'TrustedDevices.trustedAt' | translate }}</th>
                  <th>{{ 'TrustedDevices.validUntil' | translate }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let device of devices">
                  <tr>
                    <td>
                      <button type="button" class="btn btn-sm btn-link p-0 text-secondary"
                        (click)="toggleDetails(device)" [attr.aria-expanded]="isExpanded(device)"
                        [attr.aria-label]="'TrustedDevices.details' | translate">
                        <i class="fa" [ngClass]="isExpanded(device) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                      </button>
                    </td>
                    <td>
                      <span class="text-muted small">#{{ device.login_id }}</span>
                      <span *ngIf="sessionStatus(device) === 'active'" class="badge bg-success ms-1">{{ 'TrustedDevices.sessionActive' | translate }}</span>
                      <span *ngIf="sessionStatus(device) === 'ended'" class="badge bg-secondary ms-1">{{ 'TrustedDevices.sessionEnded' | translate }}</span>
                    </td>
                    <td>
                      <div class="fw-medium">{{ deviceFriendlyLabel(device) }}</div>
                      <span *ngIf="isCurrentDevice(device)" class="badge bg-success mt-1">{{ 'TrustedDevices.currentDevice' | translate }}</span>
                      <span *ngIf="device.is_trusted" class="badge bg-primary mt-1 ms-1">{{ 'TrustedDevices.trusted' | translate }}</span>
                    </td>
                    <td [title]="isLocationUnavailable(device) ? ('TrustedDevices.locationNotAvailableHint' | translate) : null">
                      <span *ngIf="locationLabel(device) !== '—'">{{ locationLabel(device) }}</span>
                      <span *ngIf="locationLabel(device) === '—' && isLocationUnavailable(device)" class="location-not-available">{{ locationNotAvailableText }}</span>
                      <span *ngIf="locationLabel(device) === '—' && !isLocationUnavailable(device)">—</span>
                    </td>
                    <td>{{ formatDate(device.created_at) }}</td>
                    <td>{{ device.is_trusted ? formatDate(device.trusted_at) : '—' }}</td>
                    <td>
                      <span *ngIf="device.is_trusted && trustExpiresAt(device)">
                        {{ formatDate(trustExpiresAt(device)) }}
                        <span class="expires-in-days d-block" *ngIf="daysUntilTrustExpires(device) !== null">
                          ({{ 'TrustedDevices.expiresInDays' | translate: { count: daysUntilTrustExpires(device) } }})
                        </span>
                      </span>
                      <span *ngIf="!device.is_trusted">—</span>
                    </td>
                    <td>
                      <div class="d-flex flex-wrap gap-1 align-items-center">
                        <button
                          *ngIf="device.is_trusted"
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          (click)="revoke(device)">
                          {{ 'TrustedDevices.remove' | translate }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary"
                          (click)="forceLogout(device)"
                          [title]="'TrustedDevices.forceLogout' | translate">
                          <i class="fa fa-sign-out me-1"></i>{{ 'TrustedDevices.forceLogout' | translate }}
                        </button>
                        <button
                          *ngIf="!device.is_trusted && isCurrentDevice(device)"
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          (click)="markAsTrusted(device)">
                          {{ 'TrustedDevices.markThisDevice' | translate }}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="isExpanded(device)" class="device-details-row">
                    <td colspan="8" class="device-details-panel">
                      <div class="device-details-inner">
                        <div class="session-overview">
                          <h6 class="device-details-section-title">{{ 'TrustedDevices.sessionOverview' | translate }}</h6>
                          <div class="session-overview-grid">
                            <div class="session-overview-item">
                              <span class="session-overview-label">{{ 'TrustedDevices.deviceInfo' | translate }}</span>
                              <span class="session-overview-value">{{ deviceFriendlyLabel(device) }}</span>
                            </div>
                            <div class="session-overview-item">
                              <span class="session-overview-label">{{ 'TrustedDevices.location' | translate }}</span>
                              <span class="session-overview-value">
                                <span *ngIf="locationLabel(device) !== '—'">{{ locationLabel(device) }}</span>
                                <span *ngIf="locationLabel(device) === '—' && isLocationUnavailable(device)" class="location-not-available">{{ locationNotAvailableText }}</span>
                                <span *ngIf="locationLabel(device) === '—' && !isLocationUnavailable(device)">—</span>
                              </span>
                            </div>
                            <div class="session-overview-item">
                              <span class="session-overview-label">{{ 'TrustedDevices.sessionStarted' | translate }}</span>
                              <span class="session-overview-value">{{ formatDate(device.created_at) }}</span>
                            </div>
                            <div class="session-overview-item" *ngIf="device.is_trusted">
                              <span class="session-overview-label">{{ 'TrustedDevices.validUntil' | translate }}</span>
                              <span class="session-overview-value">
                                {{ formatDate(trustExpiresAt(device)) }}
                                <span class="expires-in-days ms-1" *ngIf="daysUntilTrustExpires(device) !== null">({{ 'TrustedDevices.expiresInDays' | translate: { count: daysUntilTrustExpires(device) } }})</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="technical-details-toggle mt-3">
                          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleTechnicalDetails(device)">
                            <i class="fa me-1" [ngClass]="isTechnicalDetailsShown(device) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            {{ isTechnicalDetailsShown(device) ? ('TrustedDevices.hideTechnicalDetails' | translate) : ('TrustedDevices.showTechnicalDetails' | translate) }}
                          </button>
                        </div>
                        <div class="technical-details-block mt-2" *ngIf="isTechnicalDetailsShown(device)">
                          <div class="row g-2 device-details-fields">
                            <div class="col-sm-6"><strong>{{ 'TrustedDevices.sessionId' | translate }}:</strong> #{{ device.login_id }}</div>
                            <div class="col-sm-6" *ngIf="sessionFingerprintShort(device)"><strong>{{ 'TrustedDevices.sessionFingerprint' | translate }}:</strong> <code class="device-details-code small">{{ sessionFingerprintShort(device) }}</code></div>
                            <div class="col-12" *ngIf="userAgentFriendly(device.user_agent)"><strong>{{ 'TrustedDevices.browserSummary' | translate }}:</strong> {{ userAgentFriendly(device.user_agent) }}</div>
                            <div class="col-12" *ngIf="device.user_agent">
                              <strong class="d-block mb-1">{{ 'TrustedDevices.userAgent' | translate }}:</strong>
                              <div class="user-agent-block user-agent-raw">{{ device.user_agent }}</div>
                            </div>
                            <ng-container *ngIf="isCurrentDevice(device) && clientDeviceDetails">
                              <div class="col-12 mt-2"><h6 class="device-details-section-title small">{{ 'TrustedDevices.sectionLiveDevice' | translate }}</h6></div>
                              <div class="col-sm-6 col-md-4" *ngFor="let item of clientDetailKeys; trackBy: trackByClientDetailKey">
                                <span *ngIf="clientDeviceDetails[item.key] != null || (item.key === 'timezoneOffset')">
                                  <strong>{{ item.labelKey | translate }}:</strong> {{ formatClientDetailValue(item.key, clientDeviceDetails[item.key]) }}
                                </span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
